import { NgModule } from '@angular/core';

import { AutofocusDirective } from './autofocus.directive';
import { HideIfEmbedModeIsSet } from './hide-if-embed-mode-is-set.directive';

const DIRECTIVES = [AutofocusDirective, HideIfEmbedModeIsSet];
@NgModule({
  imports: [],
  declarations: DIRECTIVES,
  exports: DIRECTIVES
})
export class DirectivesModule {}



// WEBPACK FOOTER //
// ./src/app/shared/directives/directives.module.ts